import { RetailCustomerConfiguration as ApiRetailCustomerConfiguration } from '@vendasta/billing';
import { PaymentMethodType as PaymentMethodTypeApi } from '@vendasta/billing';

export interface RetailCustomerConfiguration {
  merchantId: string;
  customerId: string;
  contactId: string;
  additionalContactIds?: string[];
  autoGenerateRetailSubscriptions?: boolean;
  autoPost?: boolean;
  autoGenerate?: boolean;
  useTemplateInvoice?: boolean;
  collectionMethod?: CollectionMethod;
  invoiceDay?: number;
  netD?: number;
  memo?: string;
  nextInvoiceDate?: Date;
  paymentMethodTypes?: PaymentMethodType[];
}

export enum CollectionMethod {
  UNSET = '',
  MANUAL_COLLECTION = 'Manual Collection',
  CHARGE_AUTOMATICALLY = 'Charge Automatically',
  SEND_EMAIL = 'Send Email',
}

export enum CollectionMethodAPI {
  UNSET = '',
  MANUAL_COLLECTION = 'manual-collection',
  CHARGE_AUTOMATICALLY = 'charge-automatically',
  SEND_EMAIL = 'send-email',
}

export enum PaymentMethodType {
  ACH_DEBIT = 'ACH',
  CARD = 'Card',
  ACSS_DEBIT = 'ACSS',
  UNSET = 'Unset',
}

export function collectionMethodToApi(m: CollectionMethod | undefined | string): string {
  switch (m) {
    case CollectionMethod.MANUAL_COLLECTION:
      return CollectionMethodAPI.MANUAL_COLLECTION;
    case CollectionMethod.CHARGE_AUTOMATICALLY:
      return CollectionMethodAPI.CHARGE_AUTOMATICALLY;
    case CollectionMethod.SEND_EMAIL:
      return CollectionMethodAPI.SEND_EMAIL;
    default:
      return CollectionMethodAPI.UNSET;
  }
}

export function collectionMethodFromApi(m: string): CollectionMethod {
  switch (m) {
    case CollectionMethodAPI.MANUAL_COLLECTION:
      return CollectionMethod.MANUAL_COLLECTION;
    case CollectionMethodAPI.CHARGE_AUTOMATICALLY:
      return CollectionMethod.CHARGE_AUTOMATICALLY;
    case CollectionMethodAPI.SEND_EMAIL:
      return CollectionMethod.SEND_EMAIL;
    default:
      return CollectionMethod.UNSET;
  }
}

export function retailCustomerConfigurationFromApi(
  config: ApiRetailCustomerConfiguration,
): RetailCustomerConfiguration {
  return {
    merchantId: config.merchantId || '',
    customerId: config.customerId || '',
    contactId: config.contactId || '',
    additionalContactIds: config.additionalContactIds ?? [],
    autoGenerateRetailSubscriptions: config.autoGenerateRetailSubscriptions || false,
    autoPost: config.autoPost || false,
    autoGenerate: config.autoGenerate || false,
    useTemplateInvoice: config.useTemplateInvoice || false,
    collectionMethod: collectionMethodFromApi(config.collectionMethod),
    invoiceDay: config.invoiceDay || 0,
    netD: config.netD || 7,
    memo: config.memo || '',
    nextInvoiceDate: config.nextInvoiceDate,
    paymentMethodTypes: paymentTypesFromApi(config.paymentMethodTypes),
  };
}

function paymentTypeFromApi(t: PaymentMethodTypeApi): PaymentMethodType {
  switch (t) {
    case PaymentMethodTypeApi.PAYMENT_METHOD_TYPE_CARD:
      return PaymentMethodType.CARD;
    case PaymentMethodTypeApi.PAYMENT_METHOD_TYPE_ACH_DEBIT:
      return PaymentMethodType.ACH_DEBIT;
    case PaymentMethodTypeApi.PAYMENT_METHOD_TYPE_ACSS_DEBIT:
      return PaymentMethodType.ACSS_DEBIT;
    default:
      return PaymentMethodType.UNSET;
  }
}

export function paymentTypesFromApi(t: PaymentMethodTypeApi[]): PaymentMethodType[] {
  return t?.map(paymentTypeFromApi) || [];
}

function paymentMethodTypeToApi(t: PaymentMethodType): PaymentMethodTypeApi {
  switch (t) {
    case PaymentMethodType.CARD:
      return PaymentMethodTypeApi.PAYMENT_METHOD_TYPE_CARD;
    case PaymentMethodType.ACH_DEBIT:
      return PaymentMethodTypeApi.PAYMENT_METHOD_TYPE_ACH_DEBIT;
    case PaymentMethodType.ACSS_DEBIT:
      return PaymentMethodTypeApi.PAYMENT_METHOD_TYPE_ACSS_DEBIT;
    default:
      return PaymentMethodTypeApi.PAYMENT_METHOD_TYPE_UNSET;
  }
}

export function paymentMethodTypesToApi(t: PaymentMethodType[]): PaymentMethodTypeApi[] {
  return t?.map(paymentMethodTypeToApi) || [];
}
